// Console branding: show "TRMD Engine" instead of "bridge" in user-facing logs (exe filename untouched).
export const brandLog = (msg) =>
  typeof msg !== 'string' ? msg : msg
    .replace(/Native FTDI K-Line bridge/g, 'TRMD Engine')
    .replace(/\bTiroTuner Bridge\b/gi, 'TRMD Engine')
    .replace(/\b(?:native )?bridge\b/gi, 'TRMD Engine');
